export enum MaritalStatus {
  UNKNOWN,
  SINGLE,
  MARRIED,
  DIVORCEE,
  WIDOWER,
  SEPARATED
}
